import { render } from "./DeclareOutbreakModal.vue?vue&type=template&id=5abd0699&scoped=true"
import script from "./DeclareOutbreakModal.vue?vue&type=script&lang=js"
export * from "./DeclareOutbreakModal.vue?vue&type=script&lang=js"

import "./DeclareOutbreakModal.vue?vue&type=style&index=0&id=5abd0699&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abd0699"]])

export default __exports__